import React from "react";
import {componentTypeMatcher} from "../../common/matchers.jsx";
import optionsRepo from "../options.js";
import store from "../../../redux/store.js";

export const createForm = (dataObject = {}, props) => {

    const tooltips = store.getState()?.tooltip?.msg || {};

    const DICT_LIMITS = {
        subteams: 4,  // slownik_subteams.id max char(4)
        teams:    7,  // slownik_teams.id    max char(7)
        units:    2   // slownik_units.id    max char(2)
    };
    const currentDict = store.getState().slownikFormSelected?.name; // np. 'subteams'

    return Object.entries(dataObject).map(([name, field], idx) => {
        const Component = componentTypeMatcher[field.type]?.component;
        if (!Component) return null;
        const shouldRender =
            !field?.whenIn ||
            Object.entries(field?.whenIn).every(([key, values]) =>
                Array.isArray(values) ? values.includes(props.data?.[key]) : values === props.data?.[key]
            );
        if (!shouldRender) return null;

        const dictLimit = DICT_LIMITS[currentDict];
        const isIdField  = name === "id";
        const maxLen = isIdField && dictLimit != null
            ? dictLimit
            : field.limit;

        return (
            <div key={idx}>
                {React.cloneElement(Component, {
                    ...props,
                    key: idx,
                    name,
                    limit: maxLen,
                    tooltipText: tooltips[field.alt]?.value || field.tooltipText || '',
                    label: field.label,
                    list: props.checkListItems,
                    vertical: field.vertical,
                    type: field.type,
                    format: field.format,
                    decimal: field?.decimal ?? 2,
                    options: field.options || optionsRepo[field.optionsName],
                    value: field.type === "checklist" ? props?.checkListItems : props?.form?.[name],
                    disabled: field.disabled || props.disabled,
                    onChange: (e) => {
                        const raw =
                            field.type === "datetime"
                                ? e
                                : e.target?.value ?? e?.value ?? "";
                        props.setForm({
                            ...props.form,
                            [name]:
                                field.type === "datetime" ? e : raw,
                        });
                    },
                    dictName: field.dictName,
                    endpoint: field.endpoint,
                    setState: props.setCheckListItems,
                    initState: props.checkListInitState,
                })}
            </div>
        );
    });
}
